import {
  exists,
  CollectionListDetailBibliography,
  CollectionListDetailBibliographyFromJSON
} from '@/api'
import { CollectionListStatus } from '@/types'
import { dateToPlainFormat } from '@/utils'

export interface CollectionListDetail {
  id: number
  name: string
  nameKana: string
  releaseStartDate: string
  releaseEndDate: string
  unlimitedFlag: boolean
  status: CollectionListStatus
  priority: number
  revision: number
  bibliographies: CollectionListDetailBibliography[]
}

export const defaultCollectionListDetail = (): CollectionListDetail => ({
  id: 0,
  name: '',
  nameKana: '',
  releaseStartDate: '',
  releaseEndDate: '',
  unlimitedFlag: false,
  status: CollectionListStatus.Private,
  priority: 0,
  revision: 0,
  bibliographies: []
})

export function CollectionListDetailFromJSON(json: any): CollectionListDetail {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    releaseStartDate: exists(json, 'release_start_date')
      ? dateToPlainFormat(json.release_start_date)
      : '',
    releaseEndDate: exists(json, 'release_end_date')
      ? dateToPlainFormat(json.release_end_date)
      : '',
    unlimitedFlag: exists(json, 'unlimited_flag') ? json.unlimited_flag : false,
    status: exists(json, 'status') ? json.status : CollectionListStatus.Private,
    priority: exists(json, 'priority') ? json.priority : 0,
    revision: exists(json, 'revision') ? json.revision : 0,
    bibliographies: exists(json, 'bibliographies')
      ? json.bibliographies.map(CollectionListDetailBibliographyFromJSON)
      : []
  }
}
